import { Component, OnInit, SecurityContext } from '@angular/core';
import { IOasisScan } from 'src/app/Models/IOasisScan ';
import { Globals } from 'src/app/globals';
import { OasisService } from "../../../Services/OasisService";
import { Message } from 'primeng/primeng';
import { InitialIEPInfoService } from 'src/app/Services/InitialIEPInfoService';
import { IInitialIEPInfo } from 'src/app/Models/IInitialIEPInfo';
import { SelectedStudentService } from 'src/app/Services/SelectedStudentService';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-scanned-documents',
  templateUrl: './scanned-documents.component.html',
  styleUrls: ['./scanned-documents.component.css']
})
export class ScannedDocumentsComponent implements OnInit {
  _myGlobals: Globals;
  scannedDocumentsList: IOasisScan[] = [];
  successMessages: Message[];
  errorMessages: Message[];

  InitialIepInfoSubscription: Subscription;
  initialiepDB: IInitialIEPInfo = {} as IInitialIEPInfo;
  
  constructor(private globals: Globals, private _oasisService : OasisService, private _initialIEPInfoService:InitialIEPInfoService,    private _selectedStudentService: SelectedStudentService,
    public sanitizer : DomSanitizer ) {
    this._myGlobals = globals;
   }

  ngOnInit(): void {
    this.clearMessages();
    this.LoadScannedDocumentsList();
    this.InitialIepInfoSubscription = this._selectedStudentService.getInitialIepInfo().subscribe(
      (info: IInitialIEPInfo) => {
        this.LoadInitialIEPInfoDetailsFromExisting(info);
      }
      
    )
  }

  LoadScannedDocumentsList(): void {
    this._oasisService.getOasisScansByStudent(this._myGlobals.selectedStudent.localStudentId)
      .subscribe((res: IOasisScan[]) => {
        this.scannedDocumentsList = res;
      },
        err => {
          console.error(err);
          let errorMessage: Message = { severity: 'error', summary: 'There was no Initial IEP Info found for this student.  Please create Initial IEP Information.', detail: null };
          this.addMessage(errorMessage);
        }
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  updateMostRecentLaserficheDocumentID(laserficheDocumentID: number)
  {
    debugger;
    //alert(laserficheDocumentID);
   this.initialiepDB.localStudentId=this._myGlobals.selectedStudent.localStudentId;
   this.initialiepDB.mostRecentLaserficheDocumentId =laserficheDocumentID;
    this._initialIEPInfoService.updateMostRecentLaserficheDocumentID(this.initialiepDB)
    .subscribe((info: IInitialIEPInfo) => {
      let successMessage: Message = { severity: 'success', summary: ' ', detail:null };
      this.addMessage(successMessage);
      this._selectedStudentService.setInitialIepInfo(this.initialiepDB);
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: '', detail: null };
        this.addMessage(errorMessage);
      }
    );
  }

  ViewLaserficheDocument(laserficheDocumentID: number)
  {
    this._initialIEPInfoService.ViewLaserficheDocument(this._myGlobals.selectedStudent.localStudentId,laserficheDocumentID)
    .subscribe(result=>{ 
      const blob = new Blob([result],{type:'application/pdf'});
      saveAs(blob,"filename.pdf");
    })
  }

  LoadInitialIEPInfoDetailsFromExisting(info: IInitialIEPInfo): void {
    info.identifiedAsSPEDDate = info.identifiedAsSPEDDate == null ? null : new Date(info.identifiedAsSPEDDate);
    info.initialConsentDate = info.initialConsentDate == null ? null : new Date(info.initialConsentDate);
    info.initialIepDate = info.initialIepDate == null ? null : new Date(info.initialIepDate);
    info.spedEntryDate = info.spedEntryDate == null ? null : new Date(info.spedEntryDate);
    info.initialEvalDate = info.initialEvalDate == null ? null : new Date(info.initialEvalDate);
    info.lastEvalDate = info.lastEvalDate == null ? null : new Date(info.lastEvalDate);
    this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy = this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy == null ? '' : this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy;
    this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn = this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn == null ? null : new Date(this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn);
    this.initialiepDB.mostRecentLaserficheDocumentId=this.initialiepDB.mostRecentLaserficheDocumentId == null ? null : this.initialiepDB.mostRecentLaserficheDocumentId;
    info.spedIdentifierIdString = info.spedIdentifierId == null ? '' : info.spedIdentifierId.toString();
    info.withdrawlReason = info.withdrawlReason == null ? "" : info.withdrawlReason.toString();
    info.enteredBy = this._myGlobals.spedSecurityUser.userNameEmail;
    info.updatedBy = this._myGlobals.spedSecurityUser.userNameEmail;
    if (info.datePermissionRevoked != null) {
      info.datePermissionRevoked = new Date(info.datePermissionRevoked);
    }
    if (info.dateScanned != null) {
      info.dateScanned = new Date(info.dateScanned);
    }

    this.initialiepDB = info;
  }

}
